<div class="faq-container">
</div>
<div class="faq">
  <div class="faq-content">
    <div class="phone-head">
      <h1 class="faq-title" [innerHTML]="'FAQ' | translate"></h1>
    </div>
    <div class="mdl-cell--hide-phone mdl-cell--hide-tablet faq-content-search">
      <input [(ngModel)]="searchText" (keyup)="searchWord($event)" type="text" placeholder="{{'SEARCH' | translate}}">
      <div class="search-img">
        <i class="material-icons notranslate">search</i>
      </div>
    </div>
    <div class="no-find" *ngIf="noQuestion">
      <h3>{{'NO_MATCHES' | translate}}</h3>
    </div>
    <ng-container *ngFor="let q of auxListQuestion">
      <app-faq-card [searchText]="searchText" [answer]="q.answer" [title]="q.title"></app-faq-card>
    </ng-container>
  </div>
</div>
